import { render, staticRenderFns } from "./MobileListRelayItem.vue?vue&type=template&id=caab3476&"
import script from "./MobileListRelayItem.vue?vue&type=script&lang=ts&"
export * from "./MobileListRelayItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports